module.exports = __webpack_public_path__ + "static/media/manual.80fb6e4f.pdf";